module.exports = "/_next/static/images/game-1-intro-tutorial-suspect2-73d7830cfab3d029da4603e253f40217.jpg";